import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { GetUsersByPartnerIdAndEtablissementIdDefault } from '../../../actions/partner/partner';
import BackofficeUser from '../../../constants/models/backofficeUser';
import anticipa from './../../../assets/images/svg/112-person-white.svg';
import * as R from 'ramda';


const AnticipaHeader = ({ users, statusOptions, partnerState, isPartner }) => {

    const [headerStats, setHeaderStats] = useState({ total: 0, notAccepted: 0, finished: 0, ongoing: 0, yearAndMore: 0 });

    useEffect(() => {

        async function fetchAllAnticipaDossier() {
            if(R.isNil(partnerState.etablissement)){
                return 0;
            }

            const allAnticipaDossier = await GetUsersByPartnerIdAndEtablissementIdDefault(partnerState.partner.id, partnerState.etablissement.id, "anticipa");
            const statistics = allAnticipaDossier.items.reduce((acc, dossier) => {

                const newDossier = new BackofficeUser(dossier);
                switch (newDossier.status) {
                    case "notAccepted":
                        acc.notAccepted += 1;
                        break;
                    case "finished":
                        acc.finished += 1;
                        break;
                    case "ongoing":
                        acc.ongoing += 1;
                        break;
                    case "yearAndMore":
                        acc.yearAndMore += 1;
                        break;

                    default:
                        break;
                }
                return acc;

            }, { total: allAnticipaDossier.totalRecords, notAccepted: 0, finished: 0, ongoing: 0, yearAndMore: 0 });

            setHeaderStats(statistics);
        }
        fetchAllAnticipaDossier();
    }, []);



    return (
        <header className="rounded-bottom-left-sm rounded-top-right-sm mb-0 mb-4">
            <div className="row g-1">
                <div className="col-md-auto order-last">
                    <div className="card rounded shadow">
                        {
                            !isPartner ? 
                                <Link className="card-body p-2 media btn-alert my-auto" role="button" to="/partner/create-dossier">
                                    <div className="rounded-max btn-alert-info d-inherit rounded-max h-6 w-6 text-center">
                                        <i className="eva eva-folder-add-outline m-auto h1 lh-1" ></i>
                                    </div>
                                    <div className="media-body my-auto text-truncate text-info mx-2 d-md-none d-xl-flex">
                                        <h1 className="h5 text-uppercase font-weight-bolder my-auto text-truncate">Ajouter un <br />nouveau dossier</h1>
                                    </div>
                                </Link>
                            :
                                ""
                        }
                        
                    </div>
                </div>
                <div className="col">
                    <div className="card rounded shadow">
                        <h1 className="sr-only visually-hidden">Dossier Anticipa</h1>
                        <div className="card-body p-2 grid grid-half grid-sm-min grid-md-6">
                            <div className="grid-column-2 media">
                                <div className="rounded-max bg-gradient-primary text-white d-inherit mr-3 rounded-max h-6 w-6 text-center">
                                    <img className="img-fluid m-auto my-3 mb-2 py-1 text-white" src={anticipa} alt="Anticipa" />
                                </div>
                                <div className="media-body my-auto text-truncate">
                                    <div className="h5 o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">nombre total</div>
                                    <p className="h3 text-dark font-weight-bolder lh-solid mb-0 text-truncate">{headerStats.total} Anticipa</p>
                                </div>
                            </div>
                            <div className="px-1 px-lg-2 px-xl-1 px-hd-3 my-auto text-truncate border-left border-none border-lg-dim">
                                <div className="h5 o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">N'a pas accepté</div>
                                <p className="h3 text-dark font-weight-bolder lh-solid mb-0 text-truncate">{headerStats.notAccepted}</p>
                            </div>
                            <div className="px-1 px-lg-2 px-xl-1 px-hd-3 my-auto text-truncate border-left border-none border-lg-dim">
                                <div className="h5 o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">en cours</div>
                                <p className="h3 text-dark font-weight-bolder lh-solid mb-0 text-truncate">{headerStats.ongoing}</p>
                            </div>
                            <div className="px-1 px-lg-2 px-xl-1 px-hd-3 my-auto text-truncate border-left border-none border-lg-dim">
                                <div className="h5 o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">Complété</div>
                                <p className="h3 text-dark font-weight-bolder lh-solid mb-0 text-truncate">{headerStats.finished}</p>
                            </div>
                            <div className="px-1 px-lg-2 px-xl-1 px-hd-3 my-auto text-truncate border-left border-none border-lg-dim">
                                <div className="h5 o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">plus d'un an</div>
                                <p className="h3 text-dark font-weight-bolder lh-solid mb-0 text-truncate">{headerStats.yearAndMore}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default AnticipaHeader;
